// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#progress-info[data-v-3e269221] {\n  margin: 1em;\n}\n#progress-info h4[data-v-3e269221] {\n  margin: 0;\n  padding: 0.5em;\n  padding-top: 1em;\n}\n#progress-info h4 span[data-v-3e269221] {\n  font-weight: 300;\n}", ""]);
// Exports
module.exports = exports;
